import React from 'react';
import { motion } from 'framer-motion';
const pillars = [{
  icon: '🌅',
  title: 'PILAR 1 — EL ESCUDO DE MAÑANA',
  description: 'La ansiedad de las 2 AM nació a las 9 AM. 3 micro-pausas diurnas para que la noche no cargue el peso de todo el día.'
}, {
  icon: '📅',
  title: 'PILAR 2 — PROTOCOLO DE 90 DÍAS',
  description: 'El mapa completo mes a mes. Lo que ocurre en tu cerebro en cada fase. Trackers mensuales para medir el cambio real.'
}, {
  icon: '🛡️',
  title: 'PILAR 3 — ANATOMÍA DE LA RECAÍDA',
  description: 'Para cuando el trabajo, la pareja o la salud te tiran encima y el sistema estándar no alcanza. Protocolos de Nivel Negro.'
}, {
  icon: '📚',
  title: 'PILAR 4 — BIBLIOTECA DE CASOS',
  description: 'Los 20 bloqueos más comunes con solución exacta. Mi mente es más rápida que mi escritura. Soy inconsistente. Todos resueltos.'
}];
export function WhyCompleteOption() {
  return <section className="bg-cream py-12 md:py-24 px-4" data-id="element-418">
      <div className="max-w-6xl mx-auto text-center" data-id="element-419">
        <h2 className="font-display font-bold text-navy text-[36px] mb-8" data-id="element-420">
          ⭐ ¿Por qué elegir la opción completa?
        </h2>

        <div className="max-w-3xl mx-auto space-y-6 text-[#2D2D2D] font-sans text-lg mb-16" data-id="element-421">
          <p data-id="element-422">No es un libro para leer.</p>
          <p data-id="element-423">Es un sistema para usar.</p>
          <p data-id="element-424">
            Los 30 módulos y los 3 bonos te dan las herramientas para esta
            noche, esta semana y este mes.
          </p>
          <p data-id="element-425">
            Pero la ansiedad nocturna no desaparece en 14 días. Necesita 90 días
            para recablearse en el sistema nervioso.
          </p>
        </div>

        <div className="bg-white p-8 rounded-xl border-l-4 border-sage text-left max-w-2xl mx-auto mb-20" data-id="element-426">
          <div className="flex gap-4 items-start" data-id="element-427">
            <span className="text-2xl" data-id="element-428">🔬</span>
            <p className="text-sage font-sans italic" data-id="element-429">
              La investigación en neuroplasticidad es clara: los primeros 14
              días cambian el comportamiento. Los 90 días cambian la biología.
            </p>
          </div>
        </div>

        <div className="mb-20" data-id="element-430">
          <h3 className="font-display font-bold text-navy text-2xl mb-4 uppercase" data-id="element-431">
            🧠 EL SISTEMA DE REPROGRAMACIÓN NERVIOSA
          </h3>
          <p className="text-taupe font-sans mb-12" data-id="element-432">
            Para los 90 días que vienen.
            <br data-id="element-433" />
            Para cuando la vida se pone realmente difícil.
            <br data-id="element-434" />
            Para no volver a empezar de cero.
          </p>

          <div className="grid md:grid-cols-2 gap-6 text-left" data-id="element-435">
            {pillars.map((pillar, i) => <div key={i} className="bg-white p-8 rounded-xl border-t-4 border-gold shadow-sage-soft" data-id="element-436">
                <span className="text-3xl mb-6 block" data-id="element-437">{pillar.icon}</span>
                <h4 className="text-sage font-sans font-bold mb-4 uppercase tracking-wide" data-id="element-438">
                  {pillar.title}
                </h4>
                <p className="text-[#2D2D2D] font-sans text-sm leading-relaxed" data-id="element-439">
                  {pillar.description}
                </p>
              </div>)}
          </div>
        </div>

        <div className="bg-sage rounded-xl p-10 md:p-16 grid md:grid-cols-3 gap-12 mb-20" data-id="element-440">
          {[{
          val: '60+',
          label: 'páginas adicionales'
        }, {
          val: '4',
          label: 'Pilares de transformación'
        }, {
          val: '90',
          label: 'días de protocolo'
        }].map((item, i) => <div key={i} className="text-center" data-id="element-441">
              <p className="font-display font-bold text-gold text-[48px] mb-2" data-id="element-442">
                {item.val}
              </p>
              <p className="font-sans font-light text-cream-white text-sm uppercase tracking-widest" data-id="element-443">
                {item.label}
              </p>
            </div>)}
        </div>

        <div className="max-w-4xl mx-auto mb-16" data-id="element-444">
          <div className="rounded-xl overflow-hidden shadow-sm border border-sage-light/20" data-id="element-445">
            <div className="grid grid-cols-[1fr_50px_50px] md:grid-cols-2 bg-sage text-cream-white font-sans font-bold text-[10px] md:text-sm" data-id="element-446">
              <div className="p-4 md:p-6 text-left" data-id="element-447">BENEFICIOS</div>
              <div className="md:hidden flex items-center justify-center border-l border-white/10" data-id="element-448">
                BASE
              </div>
              <div className="md:hidden flex items-center justify-center border-l border-gold/30 bg-sage/90" data-id="element-449">
                FULL
              </div>
              <div className="hidden md:block p-6 text-left border-l-[3px] border-gold bg-sage/90" data-id="element-450">
                COLECCIÓN COMPLETA $24.990 ⭐
              </div>
            </div>

            <div className="divide-y divide-sage-light/10 bg-white" data-id="element-451">
              {[['30 módulos del manual', true, true], ['Kit 2 AM de Rescate', true, true], ['Planner 14 noches', true, true], ['Scripts 40 frases', true, true], ['Protocolo de 90 Días', false, true], ['El Escudo de Mañana', false, true], ['Trackers mensuales × 3', false, true], ['Protocolos de crisis', false, true], ['Biblioteca 20 bloqueos', false, true]].map((row, i) => <div key={i} className="grid grid-cols-[1fr_50px_50px] md:grid-cols-2 font-sans text-[11px] md:text-sm" data-id="element-452">
                  <div className="p-3 md:p-4 px-4 md:px-6 text-left flex items-center text-[#2D2D2D]" data-id="element-453">
                    {row[0]}
                  </div>

                  <div className="md:hidden flex items-center justify-center border-l border-sage-light/5" data-id="element-454">
                    <span className={row[1] ? 'text-sage' : 'text-terracotta'} data-id="element-455">
                      {row[1] ? '✅' : '❌'}
                    </span>
                  </div>

                  <div className="md:hidden flex items-center justify-center border-l border-gold/20 bg-gold/5" data-id="element-456">
                    <span className="text-sage" data-id="element-457">✅</span>
                  </div>

                  <div className="hidden md:flex p-4 px-6 text-left border-l-[3px] border-gold items-center justify-between text-[#2D2D2D] font-bold" data-id="element-458">
                    <span data-id="element-459">{row[0]}</span>
                    <span className="text-sage" data-id="element-460">✅</span>
                  </div>
                </div>)}
            </div>
          </div>
        </div>

        <p className="text-taupe font-sans italic mb-12" data-id="element-461">
          La diferencia es de $5.000.
          <br data-id="element-462" />
          El Protocolo Avanzado por separado vale $20.000.
          <br data-id="element-463" />
          Hoy lo llevás a la mitad solo porque lo sumás a la colección.
        </p>

        <div className="flex flex-col md:flex-row justify-center gap-6 items-center" data-id="element-464">
          <motion.a href="https://checkout2.guiadigital360.online/cart/44370674221149:1" animate={{
          scale: [1, 1.03, 1]
        }} transition={{
          duration: 2,
          repeat: Infinity,
          ease: 'easeInOut'
        }} whileHover={{
          scale: 1.05,
          backgroundColor: '#2D4033'
        }} whileTap={{
          scale: 0.98
        }} className="bg-sage text-cream-white font-sans font-bold py-[18px] px-[40px] rounded-[50px] text-sm" data-id="element-465">
            💛 QUIERO SOLO LA COLECCIÓN — $19.990
          </motion.a>
          <motion.a href="https://checkout2.guiadigital360.online/cart/44370707284061:1" animate={{
          scale: [1, 1.05, 1]
        }} transition={{
          duration: 2,
          repeat: Infinity,
          ease: 'easeInOut'
        }} whileHover={{
          scale: 1.08,
          backgroundColor: '#C4956A'
        }} whileTap={{
          scale: 0.95
        }} className="bg-gold text-sage-dark font-sans font-bold py-[22px] px-[50px] rounded-[50px] text-lg shadow-xl" data-id="element-466">
            ⭐ QUIERO LA COLECCIÓN COMPLETA — $24.990
          </motion.a>
        </div>
      </div>
    </section>;
}